import React from 'react';

const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div
      style={{
        animation: 'pageFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <style>{`
        @keyframes pageFadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
      {children}
    </div>
  );
};

export default PageTransition;
